import { render } from "./YokuaruQA.vue?vue&type=template&id=dbdc0292&scoped=true"
import script from "./YokuaruQA.vue?vue&type=script&lang=js"
export * from "./YokuaruQA.vue?vue&type=script&lang=js"

import "./YokuaruQA.vue?vue&type=style&index=0&id=dbdc0292&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbdc0292"]])

export default __exports__